import { OperationAccess } from 'constants/operationAccesses';

import Skeleton from '@mui/material/Skeleton';
import { usePermissions } from 'hooks/usePermissions';
import { useMerchantCredentialsJson } from 'pages/Merchants/MerchantsShow/MerchantsShowCredentials/hooks/useMerchantCredentialsJson';
import { RecordContextProvider } from 'react-admin';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { JsonCopyToClipboardField } from 'shared/react-admin/Fields';
import { MerchantCredentials } from 'types/embedded/merchant';

type Props = {
  open: boolean;
  onClose: () => void;
  actions: React.ReactNode;
  record?: MerchantCredentials;
};

export const MerchantsShowCredentialsDialog: React.FC<Props> = ({
  open,
  onClose,
  record,
  actions,
}) => {
  const { hasOperationAccess } = usePermissions();
  const { credentials, isLoading } = useMerchantCredentialsJson(
    record?.originId,
    hasOperationAccess(OperationAccess.ManageMerchantCredentials),
  );

  return (
    <Dialog
      maxWidth="sm"
      onClose={onClose}
      open={open}
      sx={{ '.MuiPaper-root': { width: '640px', maxWidth: '640px' } }}
    >
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title="Реквизиты доступа {json}"
        titleSize="smallBold"
      />
      <RecordContextProvider value={{ credentials }}>
        <CardContent>
          {isLoading ? (
            <Skeleton height={103} variant="rounded" width="100%" />
          ) : (
            <JsonCopyToClipboardField label="Доступы счёта" source="credentials" />
          )}
        </CardContent>
      </RecordContextProvider>
      {actions}
    </Dialog>
  );
};
